import { createContext } from 'react';

export const EnvContext = createContext();
export const EnvConsumer = EnvContext.Consumer;

export { default as getEnv } from './getEnv';
export { default as envPropTypes } from './propTypes';
export { default as EnvProvider } from './provider';
export { default as withEnv } from './decorator';
